
<mat-dialog-content>
    <div class="container">

        <div *ngIf="type=='pdf'" class="left-side">
            <pdf-viewer 
                [(src)]="src"
                [render-text]="true"
                [fit-to-page]="true"
                [original-size]="false"
                style="display: block;"
                class="pdf-viewer"></pdf-viewer>
        </div>

        <div *ngIf="type=='image'" class="left-side">
            <img [(src)]="src" alt="invoice">
        </div>
        <div class="properties">
            
          <div class="content">
            <mat-tab-group animationDuration="0ms" backgroundColor="primary" dynamicHeight>

                <mat-tab label="Details">
            
                  <mat-form-field appearance="outline">
                    <mat-label>Select an category</mat-label>
                    <mat-select [(value)]="pendingEvidence.category">
                      <mat-option>None</mat-option>
                      <mat-option value="expenses">Expenses</mat-option>
                      <mat-option value="revenue">Revenue</mat-option>
                      <mat-option value="wages">Wages</mat-option>
                    </mat-select>
                  </mat-form-field>
                
                  <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Note</mat-label>
                    <input matInput [(ngModel)]="pendingEvidence.note">
                  </mat-form-field>

                  <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Amount in cents</mat-label>
                    <input matInput [(ngModel)]="pendingEvidence.amount">
                  </mat-form-field>

                  <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Note</mat-label>
                    <input matInput [(ngModel)]="pendingEvidence.note">
                  </mat-form-field>

                  <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Filename</mat-label>
                    <input matInput [(ngModel)]="pendingEvidence.file">
                  </mat-form-field>

                  <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>SHA-1 Hash</mat-label>
                    <input matInput [value]="pendingEvidence.sha1">
                  </mat-form-field>

                  <ng-container *ngIf="existingTransactions.length > 0">
                    <h2>Existing Transactions</h2>
                    <div *ngFor="let transaction of existingTransactions">
                      {{transaction.date | date:'dd-MM-yy'}} -- {{transaction.description}} --- {{transaction.amount | human}}
                    </div>
                  </ng-container>

                </mat-tab>

              </mat-tab-group>
            </div>


            <div class="footer confirm-evidence">
              <mat-dialog-actions align="end">
                <button (click)="prev()" mat-raised-button>Previous</button>
                <button (click)="next()" mat-raised-button>Next</button>
                <button (click)="deletePendingEvidence()" mat-raised-button>Delete</button>
                <button mat-raised-button mat-dialog-close>Cancel</button>
                <button (click)="save()" mat-raised-button>Save</button>
                <button (click)="saveAndClose()" mat-raised-button>Save and Close</button>
              </mat-dialog-actions>
            </div>
        </div>
    </div>
</mat-dialog-content>
  
